import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function CreativeHairProfessionalLevel3() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk2.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    Advanced and Creative Hairdressing Level 3
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    ST0214 - Master Advanced Hairdressing Techniques
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content Section */}
        <section id="creative-hair-professional-level-3" className="creative-hair-professional section" style={{ padding: '80px 0' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>        

                  {/* Introduction */}
                  <div className="mb-5">
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      The level 3 hairdressing apprenticeship is perfect for learners who want to expand their knowledge and skills to become a more creative and technical hairdresser. It will make you a more technical stylist with advanced and specialised hairdressing skills.
                    </p>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      The Advanced Hairdressing Apprenticeship is available for any learner above the age of 16. We would recommend that all learners complete the Hair Professional Apprenticeship Level 2 before embarking on the advanced Level 3 program.
                    </p>
                  </div>

                  {/* Duration */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      Duration
                    </h4>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      12 - 15 months. During your apprenticeship, you will be earning a wage while learning hairdressing skills. You will be employed in a salon for a minimum of 30 hours per week and will be entitled to all the work benefits of your qualified colleagues.
                    </p>
                  </div>

                  {/* The Qualification */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      The Qualification
                    </h4>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      During the apprenticeship you will be assessed on your knowledge and understanding of the six mandatory units. These assessments will be completed by your Assessor to the requirements of the awarding body such as VTCT, or TQUK.
                    </p>

                    <div className="mb-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                      <p style={{ color: '#495057', fontSize: '1.05rem', marginBottom: 0 }}>
                        Click for more information: <a href="https://www.instituteforapprenticeships.org/apprenticeship-standards/advanced-and-creative-hair-professional-v1-0" target="_blank" rel="noopener noreferrer" style={{ color: '#7B3F9E', textDecoration: 'none', fontWeight: '600' }}>Advanced and creative hair professional / Skills England</a>
                      </p>
                    </div>
                  </div>

                  {/* The Units */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      The Units
                    </h4>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px' }}>
                      There are six mandatory units and to be awarded the Advanced and Creative Hairdressing Apprenticeship you must achieve in all these.
                    </p>

                    <div style={{ 
                      display: 'grid', 
                      gridTemplateColumns: '1fr', 
                      gap: '15px',
                      marginBottom: '20px'
                    }}>
                      <div style={{ 
                        padding: '20px', 
                        backgroundColor: '#f8f9fa', 
                        borderRadius: '8px',
                        border: '1px solid #dee2e6',
                        borderLeft: '4px solid #7B3F9E'
                      }}>
                        <p style={{ color: '#495057', fontSize: '1.05rem', fontWeight: '600', marginBottom: 0 }}>
                          1. Consultation
                        </p>
                      </div>
                      <div style={{ 
                        padding: '20px', 
                        backgroundColor: '#f8f9fa', 
                        borderRadius: '8px',
                        border: '1px solid #dee2e6',
                        borderLeft: '4px solid #7B3F9E'
                      }}>
                        <p style={{ color: '#495057', fontSize: '1.05rem', fontWeight: '600', marginBottom: 0 }}>
                          2. Advanced and creative cutting services
                        </p>
                      </div>
                      <div style={{ 
                        padding: '20px', 
                        backgroundColor: '#f8f9fa', 
                        borderRadius: '8px',
                        border: '1px solid #dee2e6',
                        borderLeft: '4px solid #7B3F9E'
                      }}>
                        <p style={{ color: '#495057', fontSize: '1.05rem', fontWeight: '600', marginBottom: 0 }}>
                          3. Creative fashion styling and finishing services
                        </p>
                      </div>
                      <div style={{ 
                        padding: '20px', 
                        backgroundColor: '#f8f9fa', 
                        borderRadius: '8px',
                        border: '1px solid #dee2e6',
                        borderLeft: '4px solid #7B3F9E'
                      }}>
                        <p style={{ color: '#495057', fontSize: '1.05rem', fontWeight: '600', marginBottom: 0 }}>
                          4. Smoothing and strengthening services
                        </p>
                      </div>
                      <div style={{ 
                        padding: '20px', 
                        backgroundColor: '#f8f9fa', 
                        borderRadius: '8px',
                        border: '1px solid #dee2e6',
                        borderLeft: '4px solid #7B3F9E'
                      }}>
                        <p style={{ color: '#495057', fontSize: '1.05rem', fontWeight: '600', marginBottom: 0 }}>
                          5. Advanced and creative colouring services
                        </p>
                      </div>
                      <div style={{ 
                        padding: '20px', 
                        backgroundColor: '#f8f9fa', 
                        borderRadius: '8px',
                        border: '1px solid #dee2e6',
                        borderLeft: '4px solid #7B3F9E'
                      }}>
                        <p style={{ color: '#495057', fontSize: '1.05rem', fontWeight: '600', marginBottom: 0 }}>
                          6. Using fashion forward trends in hair, and creative and precision techniques to create a collection of hairstyle looks
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Method of Delivery */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      Method of delivery
                    </h4>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      Hairdressing apprentices attend teaching classes on a day-release basis and work for their employer for the rest of the time. You will also receive monthly salon visits from your educator to support you through the training.
                    </p>
                  </div>

                  {/* How Will I Be Assessed */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      How Will I Be Assessed
                    </h4>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      You will be assessed in the practical environment and be required to complete assignments and exams to produce a portfolio of evidence. Continual assessment will take place throughout the duration of the apprenticeship. Once this has been achieved you will then be required to take the End Point Assessment.
                    </p>
                  </div>

                  {/* Completing The Apprenticeship */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      Completing The Apprenticeship
                    </h4>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      At the end of your hairdressing apprenticeship, after you have successfully completed the unit assessments, you will receive a Certificate of Unit Achievement. This allows you to progress onto the Gateway stage of the apprenticeship.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      The Gateway is a period where we will review your knowledge, skills and behaviours to see if you have met the minimum requirements and are ready to take the End Point Assessment.
                    </p>
                  </div>

                  {/* What is the End Point Assessment? */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      What is the End Point Assessment?
                    </h4>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      The End Point Assessment or EPA is an assessment of all the knowledge, skills and behaviours you have learned throughout your apprenticeship.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      After you have passed all the elements of the EPA, including any required standards in English and Maths, you will receive your apprenticeship certificate.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px', fontWeight: '600' }}>
                      The End Point Assessment (EPA) will comprise of:
                    </p>
                  </div>

                  {/* EPA Components */}
                  <div className="mb-5 p-4" style={{ backgroundColor: '#e7f3ff', border: '1px solid #b3d9ff', borderRadius: '12px' }}>
                    <div style={{ marginBottom: '30px' }}>
                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        marginBottom: '15px',
                        padding: '15px',
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                      }}>
                        <div style={{ 
                          width: '50px', 
                          height: '50px', 
                          borderRadius: '50%', 
                          backgroundColor: '#7B3F9E', 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center',
                          marginRight: '20px',
                          flexShrink: 0
                        }}>
                          <span style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '700' }}>1</span>
                        </div>
                        <p style={{ color: '#495057', fontSize: '1.05rem', marginBottom: 0, fontWeight: '600' }}>
                          90-minute on-line test
                        </p>
                      </div>

                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        marginBottom: '15px',
                        padding: '15px',
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                      }}>
                        <div style={{ 
                          width: '50px', 
                          height: '50px', 
                          borderRadius: '50%', 
                          backgroundColor: '#7B3F9E', 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center',
                          marginRight: '20px',
                          flexShrink: 0
                        }}>
                          <span style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '700' }}>2</span>
                        </div>
                        <p style={{ color: '#495057', fontSize: '1.05rem', marginBottom: 0, fontWeight: '600' }}>
                          Observation and questioning
                        </p>
                      </div>

                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        padding: '15px',
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                      }}>
                        <div style={{ 
                          width: '50px', 
                          height: '50px', 
                          borderRadius: '50%', 
                          backgroundColor: '#7B3F9E', 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center',
                          marginRight: '20px',
                          flexShrink: 0
                        }}>
                          <span style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '700' }}>3</span>
                        </div>
                        <p style={{ color: '#495057', fontSize: '1.05rem', marginBottom: 0, fontWeight: '600' }}>
                          Professional discussion based on your Collection of looks lasting 45 minutes
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* What Does the Future Hold? */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      What Does the Future Hold?
                    </h4>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      After you have completed your Advanced and Creative Hairdressing apprenticeship you will have reached the pinnacle of hairdressing apprenticeships and are able to become a State Registered Hairdresser (SRH) with The Hairdressing Council (<a href="https://haircouncil.org.uk" target="_blank" rel="noopener noreferrer" style={{ color: '#7B3F9E', textDecoration: 'none', fontWeight: '600' }}>haircouncil.org.uk</a>).
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      With your qualification, there are many exciting career opportunities awaiting you, from working in high-end salons to starting your own hairdressing business.
                    </p>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default CreativeHairProfessionalLevel3;